import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import Sticky from "Components/Sticky";
import { ReactComponent as BackIcon } from "Icons/back.svg";
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import Button from "Components/Button";
import Checkbox from "Components/Checkbox";
import Dropdown from "Components/Dropdown";
import { DateRangePicker } from "react-dates";
import classNames from "classnames";
import Moment from 'moment';
import Upload from "Components/Upload";
import Cx from "classnames";
import TransportersCard from 'Components/TransportersCard';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import Preview from 'Icons/rfqSingleMode.png';
import { 
    GET_GROUPS_AND_TRANSPORTERS,
    GET_RFQ_EVENT,
    GET_CONTRACT_TENURE_LIST,
    GET_PRICING_BASIS,
    GET_PACKING_TYPES,
    GET_PAYMENT_CYCLES,
    GET_PRODUCT_CATEGORIES,
    UPLOAD_DOCUMENT,
    DOWNLOAD_UPLOADED_FILE,
    CANCEL_EVENT,
    POST_EVENT_DETAILS,
    SCHEDULE_EVENT
} from 'Constants/actionConstants';
import { SERVICE_MODES, SERVICE_TYPES, INSURANCE_BY, CARGO_DETAILS, HANDLING_INSTRUCTIONS } from 'Constants/commonConstants';
import RFQ from 'Models/RFQ';
import { getUser } from 'Utils/storage';
import ReactTooltip from 'react-tooltip';
import {v4 as uuidv4} from 'uuid';
import ActionLoader from "Components/ActionLoader/index";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";

class NewEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rfq: props.rfq
        }
    }

    componentDidMount() {
        this.searchGroupsAndTransporters();
        this.getEvent();
        const { dispatch } = this.props;
        dispatch({
          type: GET_CONTRACT_TENURE_LIST
        });
        this.getConstansValues();
    }

    componentWillReceiveProps(nextProps, props) {
      if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
         this.getConstansValues((nextProps.selectedNavBranch || {}).branch_id);
      }
   }

    getEvent = () => {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_RFQ_EVENT,
            params: {
                eventId: (match.params || {}).eventId,
                rfqType: 1,
                rfqId: (match.params || {}).rfqId
            },
            onSuccess: (data) => {
                this.setState({
                    rfq: data
                })
            }
        })
    }

    toggleServiceMode = (option) => {
        const { rfq } = this.state;
        
        rfq.rfqDetails.setServiceModes([option.value]);
        rfq.rfqDetails.serviceModes = [option.value];
        this.setState({
            rfq
        })
    }

    toggleServiceType = (type) => {
        const { rfq } = this.state;
        rfq.rfqDetails.setServiceType(type.value, type.name);
        rfq.rfqDetails.serviceType = type.value;
        rfq.rfqDetails.serviceTypeName = type.name;
        rfq.rfqDetails.setServiceModes([]);
        rfq.cargoInfo.setCargoDetails([1]);
        this.setState({
            rfq
        })
     }

     selectInsuranceBy = (option) => {
        const { rfq } = this.state;
        rfq.rfqDetails.setInsuranceBy(option.value);
        rfq.rfqDetails.insuranceBy = option.value;
        this.setState({
            rfq
        });
     }


    searchGroupsAndTransporters = (search, type = 2, isMultimode, isWarehouse, movementType) => {
    const { dispatch, match } = this.props;
    const branchLocalName = localStorage.getItem('branchDetail');
    const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
    dispatch({
        type: GET_GROUPS_AND_TRANSPORTERS,
        params: {
            search,
            branchId: name.branch_id,
            type,
            isMultimode: isMultimode || undefined,
            isWarehouse: ((match.params || {}).type === 7) && true || isWarehouse || undefined,
            rfqType: 1,
            movementType: movementType || undefined
        }
    })
  }

  calculateMovmentType = () => {
    const { rfq } = this.state;
    const { rfqDetails } = rfq;
    const { contractTenureList } = this.props;
    if (rfqDetails.contractTenureFrom && rfqDetails.contractTenureTo) {
       const momentFrom = Moment(rfqDetails.contractTenureFrom);
       const momentTo = Moment(rfqDetails.contractTenureTo);
       const duration = Moment.duration(momentTo.diff(momentFrom));
       // let days = duration.days() + 1;
       const days = Math.floor(duration.asDays());

       if (duration.months() > 0 || days >= 0) {
          let type = 1;
          let typeName = "";
          if(contractTenureList && contractTenureList.length > 0 && rfqDetails.serviceType !== 4) {
             let isDone = false;
             (contractTenureList || []).map(el => {
                if(el.uom === 'weeks') {
                   el.fromRange = el.fromRange * 7;
                   el.toRange = el.toRange && (el.toRange * 7) || el.toRange;
                } else if(el.uom === 'months') {
                   el.fromRange = el.fromRange * 30;
                   el.toRange = el.toRange && (el.toRange * 30) || el.toRange;
                }
                if(days >= el.fromRange && (el.toRange ? days <= el.toRange : true) && !isDone) {
                   isDone = true;
                   typeName = el.contract_type;
                   type = el.contract_type_id;
                }
             })
          } else if(rfqDetails.serviceType === 4) {
             if(days >= 1 && days <= 7) {
                type = 2;
                typeName = "Short";
             } else if(days > 7) {
                type = 4;
                typeName = "Long";
             }
          } else {
             switch (true) {
                case (duration.months() === 0 && days === 1 && rfqDetails.serviceType !== 4):
                   type = 1;
                   typeName = "Spot";
                   break;

                case (duration.months() === 0 && (days >= 2 && days <= 7) && rfqDetails.serviceType !== 4):
                   type = 2;
                   typeName = "Short";
                   break;

                case (duration.months() === 0 && (days >= 8 && days <= 31) && rfqDetails.serviceType !== 4):
                   type = 3;
                   typeName = "Monthly";
                   break;
                case (days > 31 && rfqDetails.serviceType !== 4):
                case (duration.months() > 0 && rfqDetails.serviceType !== 4):
                   type = 4;
                   typeName = "Long";
                   break;

                case (duration.months() === 0 && (days >= 1 && days <= 7) && rfqDetails.serviceType === 4):
                   type = 5;
                   typeName = "Short";
                   break;

                case (duration.months() === 0 && (days > 7) && rfqDetails.serviceType === 4):
                   type = 6;
                   typeName = "Long";
                   break;

                default:
                   type = -1;
                   break;
             }
          }
          rfqDetails.setMovementType(type, typeName);
          rfq.rfqDetails.movementType = type;
          rfq.rfqDetails.movementTypeName = typeName;
       }
    } else {
      rfqDetails.setMovementType(-1, "");
      rfq.rfqDetails.movementType = -1;
      rfq.rfqDetails.movementTypeName = "";
    }
    return rfqDetails.movementTypeName;
 }
 toggleCargo = (option)=> {
  const { rfq } = this.state;
  rfq.cargoInfo.setCargoDetails([option.value]);
  rfq.cargoInfo.cargoDetails = [option.value];
  this.setState({
      rfq
  });
}

onDescriptionChange = (e) => {
  const { rfq } = this.state;
  rfq.cargoInfo.setCargoDescription(e.target.value);
  rfq.cargoInfo.cargoDescription = e.target.value;
  this.setState({
    rfq
  });
}

getConstansValues = (branchId = '') => {
  const { dispatch } = this.props;
  const user = getUser();
  const params = {
     rfqType: 1,
     companyId: user.companyId,
     branchId: branchId ? branchId : user.branchId
  }
  dispatch({
     type: GET_PRICING_BASIS,
     data: params
  });
  dispatch({
     type: GET_PACKING_TYPES,
     data: params
  });
  dispatch({
     type: GET_PAYMENT_CYCLES,
     data: params
  });
  dispatch({
     type: GET_PRODUCT_CATEGORIES,
     data: params
  });
}

selectProductCategory = (productCategory)=> {
  const { rfq } = this.state;
  rfq.cargoInfo.setProductCategory(productCategory.value, productCategory.name);
  rfq.cargoInfo.productCategory = productCategory.value;
  rfq.cargoInfo.productCategoryName = productCategory.name;
  this.setState({
    rfq
  });
}

selectPackingType = (packingType)=> {
  const { rfq } = this.state;
  rfq.cargoInfo.setPackingType(packingType.value, packingType.name);
  rfq.cargoInfo.packingType = packingType.value;
  rfq.cargoInfo.packingTypeName =  packingType.name;
  this.setState({
      rfq
  })
}

toggleInstructions = (option)=> {
  const { rfq } = this.state;
  rfq.cargoInfo.setHandlingInstructions([option.value]);
  rfq.cargoInfo.handlingInstructions = [option.value]
  this.setState({
      rfq
  });
}

changePaymentTerms = (value, name)=> {
  const { rfq } = this.state;
  rfq.biddingDetails.setPaymentTerms(value, name);
  rfq.biddingDetails.paymentTerms = value;
  rfq.biddingDetails.paymentTermsName = name;
  this.setState({
      rfq
  });
}

onSelect = (value, name)=> {
  const { rfq } = this.state;
  rfq.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
  if(name === 'paymentCycle') {
    rfq.biddingDetails.paymentCycle = value.value;
    rfq.biddingDetails.paymentCycleName = value.name;
  } else {
    rfq.biddingDetails.pricingBasis = value.value;
    rfq.biddingDetails.pricingBasisName = value.name;
  }  
  this.setState({
      rfq
  });
}

onChange= (file)=> {
    const { dispatch } = this.props;
    dispatch({
       type: UPLOAD_DOCUMENT,
       file,
       onSuccess: (data) => {
        const { rfq } = this.state;
        this.setState({
          rfq
        })
       }
    });
}

removeDocument = (index) => {
  const { rfq } = this.state;
  rfq.removeDocument(index);
  rfq.documents.splice(index, 1);
  this.setState({ rfq });
}

downloadUploadedFile = (fileName) => {
  const { dispatch } =  this.props;
  dispatch({
     type: DOWNLOAD_UPLOADED_FILE,
     param: {
        fileName
     }
  })
}

handleContractNotes = (e) => {
  const { rfq } = this.state;
  rfq.rfqDetails.setContractNote(e.target.value);
  rfq.rfqDetails.contractNote = e.target.value;
  this.setState({
    rfq
  })
}

onCancel = () => {
  const { dispatch, history} = this.props;
  const { rfq } = this.state;
  dispatch({
    type: CANCEL_EVENT,
    data: {
      eventId: rfq.event_id
    },
    onSuccess: () => {
      history.push('/eventManagement');
    }
  })
}

onSaveEvent = (type) => {
  const { dispatch } = this.props;
  const { rfq } = this.state;
  const rfqDetails = rfq.getApiData();
  rfqDetails.status = 2;
  rfqDetails.is_draft = false;
  dispatch({
    type: POST_EVENT_DETAILS,
    data: rfqDetails,
    status: type
  })
}

onScheduleEvent = () => {
  const { dispatch, match } = this.props;
  dispatch({
    type: SCHEDULE_EVENT,
    params: {
      eventId: match.params.eventId,
      rfqType: 1,
      rfqId: (match.params || {}).rfqId
    }
  })
}


validateData = () => {
  const { rfq } = this.state;
  const rfqData = rfq.getApiData();
  let eFlag = true;
  if(!rfq.rfqDetails.contractTenureTo || (rfq.cargoInfo.cargoDetails && rfq.cargoInfo.cargoDetails.length === 0) || !rfq.cargoInfo.cargoDescription || (rfq.documents || []).length === 0 || ((((rfqData || {}).docs_and_transporters || {}).transporters || {}).transporter_ids || []).length === 0) {
    eFlag = true;
  } else {
    eFlag = false;
  }
  return eFlag;
}

goBack = () => {
  const { history, match } = this.props;
  if(this.props.isPreview) {
    location.href = `/uploadRFQ/${match.params.eventId}/${match.params.rfqId}`;
  } else {
    history.push('/eventManagement');
  }
};

  render() {
    const { rfq } = this.state;
    const { transporters, groups, contractTenureList, productCategories, packingTypes, paymentCycles, pricingBasis, loader, eventDetails, match, isPreview } = this.props;
    const user = getUser();

    return (
     <div style={{ backgroundColor: "#e3e9ff"}}>
      {loader && <ActionLoader fixed={true} />}
      <Sticky>
        <section className=" pr-20 pl-20 pt-25 event-management">
          <section className="trip-title-container flex flex-between mb-10">
            <div className="flex flex-middle flex-1 curP">
              <Link
                  className="flex flex-middle wt-max-content theme-color fs-22 mr-20"
                  to={isPreview ? `/uploadRFQ/${match.params.eventId}/${match.params.rfqId}` : '/eventManagement'}
                >
                <BackIcon className="mr-10 fill-theme curP fBold" />
                Back
              </Link>
             { rfq && rfq.event_id &&  <>{
              this.props.isPreview ? <span className="theme-color fs-22 fBolder">{rfq.event_id}</span> :
              <span className="fBold header-text fs-24">{'New Event'}</span>
             }
             </>}
            </div>
          </section>
          {rfq && rfq.event_id && <>
          <section className="pl-15 mt-20 flex separator" />
          <section className={" pl-20 pr-20 pt-20 pb-20 br-5"}>
            <header className="fBolder fs-18 header-text">Basic Details</header>
            <header className="fBolder fs-16 mt-20 Sub-header-text">
              Service Type <span className='error-color fs-16 fBold'>*</span>
            </header>
            <section className=" mb-10 flex mt-10">
                {(SERVICE_TYPES || []).map((type, index) => {
                   if([6,7,8,9].includes(type.value)) {
                    return;
                   }
                    return (
                        <div className="mr-30 flex" key={index}>
                            <Checkbox 
                            onCheck={() => this.toggleServiceType(type)} 
                            checked={rfq.rfqDetails.serviceType === type.value} 
                            label={type.name || ''}
                            className="mr-30"
                            />
                        </div>
                    )
                })}
              <div className="flex-75 mr-20">
                <div className="fs-12 Sub-header-text">Service Mode</div>
                <Dropdown
                  items={SERVICE_MODES}
                  label="Select service mode"
                  displayKey="name"
                  selectedItem={SERVICE_MODES.find(serviceMode =>{return (rfq.rfqDetails.serviceModes || []).includes(serviceMode.value)})}
                  border-light={"noBorder"}
                  className={Cx('event-select wt-200 br-5')}
                  onSelect={this.toggleServiceMode}
                />
              </div>
             
              <div className="wt-350 ">
              <div className="fs-12 Sub-header-text">
                  Contract Tenure<sup className="danger-color pr t-4">*</sup>
                  <span className="fs-12 ml-30 fs-16 fBold success-color">
                     {(rfq.original_rfq_id && !user.isSpotContract) ? rfq.rfqDetails.movementTypeName : this.calculateMovmentType()}
                  </span>
                  {
                     ((rfq.original_rfq_id && !user.isSpotContract) ? rfq.rfqDetails.movementTypeName : this.calculateMovmentType()) && rfq.rfqDetails.serviceType !== 4  &&
                     <Fragment>
                        <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                        <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                           {contractTenureList && contractTenureList.length > 0 ?
                           <>{(contractTenureList || []).map((contract, index) => ( 
                                 <>
                                    {contract.contract_type_id !== 4 ? 
                                    <>
                                       <span>{`${contract.contract_type} : ${contract.fromRange} - ${contract.toRange} ${contract.uom}`}</span><br/>
                                    </> :
                                    <span>{`${contract.contract_type} : Above ${contract.fromRange} ${contract.uom}`}</span>}
                                 </>))}
                           </> :
                           <>
                              <span> Spot : 1 Day </span><br />
                              <span> Short : 2 - 7 Days </span><br />
                              <span> Monthly : 8 - 31 Days </span><br />
                              <span> Long : Above 31 Days </span><br />
                           </>}
                        </ReactTooltip>
                     </Fragment>
                  }
                  {
                     ((rfq.original_rfq_id && !user.isSpotContract) ? rfq.rfqDetails.movementTypeName : this.calculateMovmentType()) && rfq.rfqDetails.serviceType === 4 && 
                     <Fragment>
                        <a data-tip data-for='contract-tenture-tooltip'> <span className="tooltip-icon fBold">i</span> </a>
                        <ReactTooltip id='contract-tenture-tooltip' type="dark" effect="solid">
                           <span> Short : 0 - 7 Days </span><br />
                           <span> Long : Above 7 Days </span><br />
                        </ReactTooltip>
                     </Fragment>
                  }
               </div>
              {/* <DateRangePicker
                  startDate={ this.state.startDate}
                  startDateId="startDate"
                  endDate={ this.state.endDate}
                  endDateId="endDate"
                  // onDatesChange={({ startDate, endDate }) => {
                  //     const { data } = this.state;
                  //     const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                  //     data['contractTenureFrom'] = startDateTime;
                  //     const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                  //     data['contractTenureTo'] = endTime ? new Date(endTime).getTime() : data.contractTenureTo;
                  //     this.setState({ data })
                  // }}
                  focusedInput={this.state.focusedInput}
                  onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                  displayFormat={'DD MMM YYYY'}
                  className="wt-250"
                  noBorder={true}
                  minimumNights={0}
              /> */}
              <div className="mb-40" >
                  <DateRangePicker
                     startDate={!rfq.rfqDetails.contractTenureTo ? Moment(rfq.rfqDetails.contractTenureFrom || null) : Moment(rfq.rfqDetails.contractTenureFrom)}
                     startDateId="startDate"
                     endDate={rfq.rfqDetails.contractTenureTo ? Moment(rfq.rfqDetails.contractTenureTo) : null}
                     endDateId="endDate"
                     onDatesChange={({ startDate, endDate }) => {
                      const { rfq } = this.state;
                        const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                        rfq.rfqDetails.setContractTenureFrom(startDateTime);
                        rfq.rfqDetails.contractTenureFrom = new Date(startDateTime).setHours(0, 0, 0, 0);
                        const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                        rfq.rfqDetails.setContractTenureTo(endTime ? new Date(endTime).getTime() : this.state.endDate);
                        rfq.rfqDetails.contractTenureTo = (endTime ? new Date(endTime).getTime() : this.state.endDate);
                        this.setState({
                          rfq
                        })
                     }}
                     focusedInput={this.state.focusedInput}
                     onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                     displayFormat={'DD MMM YYYY'}
                     noBorder={true}
                     minimumNights={0}
                    //  isOutsideRange={(date) => this.checkIsRangeOutSide(rfqDetails.contractTenureFrom, date)}
                  />
               </div>
          </div>
            </section>
            <div className="flex">
              <div>
                <header className="fBolder fs-18 mb-20 Sub-header-text">
                  Insurance By <span className='error-color fs-16 fBold'>*</span>
                </header>
                <section className="flex  mb-10 flex mr-30">
                    {INSURANCE_BY.map((insuranceBy, index) => {
                        return (
                            <Checkbox
                            key={index}
                            className="mr-50"
                            label={insuranceBy.name}
                            checked={rfq.rfqDetails.insuranceBy === insuranceBy.value} 
                            onCheck={() => this.selectInsuranceBy(insuranceBy)}
                        />
                        )
                    })}
                </section>
              </div>
            </div>
          </section>
          <section className="pl-15 mt-20 flex separator" />
          <section
            className={" pl-20 pr-20 pt-20 pb-20 br-5 border-1px-regent-gray"}
          >
            <header className="fBolder fs-18 header-text">
              Cargo Information
            </header>
            <header className="fBolder fs-18 mt-20 Sub-header-text">
              Cargo Details <span className='error-color fs-16 fBold'>*</span>
            </header>
            <section className=" mb-10 mt-10 flex ht-70 ">
              <div className="  flex">
                {CARGO_DETAILS.map((cargo, index) => (<Checkbox
                  key={index}
                  className="mr-50"
                  label={cargo.name}
                  checked={rfq.cargoInfo.cargoDetails.includes(cargo.value)}
                  onCheck={() => this.toggleCargo(cargo)}
                />))}
                <div style={{ width: "500px" }}>
                  <header className="fBolder fs-18 mb-10 Sub-header-text">
                    Cargo discription
                    <span className='error-color fs-16 fBold'>*</span>
                  </header>
                  <div>
                    <textarea
                      style={{ border: "1px solid blue" }}
                      className={"col-1 br-5 pb-5 pt-5 fs-14 "}
                      value={rfq.cargoInfo.cargoDescription}
                      onChange={this.onDescriptionChange}
                    />
                  </div>
                </div>
              </div>
            </section>
            <section
              className="flex  mb-10 flex mr-30"
              style={{ width: "850px" }}
            >
              <div className="flex-1 mr-20">
                <div className="fs-12 theme-color fBold event-management-form-label">
                  Product category
                </div>
                <Dropdown
                  className={Cx('event-select wt-200 br-5')}
                  items={productCategories} 
                  label="Select.." 
                  displayKey="name" 
                  selectedItem={productCategories.find((productCategory)=> {
                      return productCategory.value === rfq.cargoInfo.productCategory
                  })}
                  onSelect = {this.selectProductCategory}
                />
              </div>
              <div className="flex-1 mr-20">
                <div className="fs-12 theme-color fBold event-management-form-label">
                  Packing Type
                </div>
                <Dropdown
                  items={packingTypes} 
                  label="Select.." 
                  displayKey="name" 
                  selectedItem={packingTypes.find((packingType)=> {
                      return packingType.value === rfq.cargoInfo.packingType
                  })}
                  onSelect = {this.selectPackingType}
                  className={Cx('event-select wt-200 br-5')}
                />
              </div>
              <div className="flex-1 mr-20">
                <div className="fs-12 theme-color fBold event-management-form-label">
                  Handling Instruction
                </div>
                <Dropdown
                  items={HANDLING_INSTRUCTIONS}
                  label={"Select"}
                  displayKey="name" 
                  selectedItem={HANDLING_INSTRUCTIONS.find((option)=> {
                    return rfq.cargoInfo.handlingInstructions.includes(option.value)
                  })}
                  onSelect={this.toggleInstructions}
                  className={Cx('event-select wt-200 br-5')}
                />
              </div>
            </section>
            <section className=" mb-10  flex"></section>
          </section>
          <section className="pl-15 mt-20 flex separator" />
          <section
            className={
              " pl-20 pr-20 pt-20 pb-20 br-5 border-1px-regent-gray mt-20"
            }
          >
            <header className="fBolder fs-18 header-text">
              Payment Detail
            </header>
            <header className="fBolder fs-18 mt-20 Sub-header-text">
              Payment Terms <span className='error-color fs-16 fBold'>*</span>
            </header>
            <section className=" mb-10 flex mt-10" style={{ width: "900px" }}>
              <div className="  flex">
                <Checkbox
                  checked = {rfq.biddingDetails.paymentTerms === 2}
                  className="mr-50"
                  label={"To be Billed"}
                  onCheck={this.changePaymentTerms.bind(this, 2, 'To Be Billed')}
                />
                <Checkbox
                  className="mr-50"
                  label={"To Pay"}
                  checked = {rfq.biddingDetails.paymentTerms === 1}
                  onCheck={this.changePaymentTerms.bind(this, 1, 'To Pay')}
                />
                <Checkbox
                  className="mr-50"
                  label={"Both"}
                  checked = {rfq.biddingDetails.paymentTerms === 3} 
                  onCheck={this.changePaymentTerms.bind(this, 3, 'Both')}
                />
              </div>
              <div className="flex-1 mr-20">
                <div className="fs-12 theme-color fBold event-management-form-label">
                  Payment Cycle 
                  {/* <span className='error-color fs-16 fBold'>*</span> */}
                </div>
                <Dropdown
                  className={Cx('event-select wt-200 br-5')}
                  items={paymentCycles} 
                  selectedItem={paymentCycles.find(paymentCycle=>{return rfq.biddingDetails.paymentCycle === paymentCycle.value})}
                  displayKey="name" 
                  name="paymentCycle" 
                  label="Select..." 
                  canClear={true}
                  onSelect={this.onSelect}
                />
              </div>
              <div className="flex-1  ">
                <div className="fs-12 theme-color fBold event-management-form-label">
                  Pricing Basic
                </div>
                <Dropdown
                  items={pricingBasis} 
                  selectedItem={pricingBasis.find(pricingBasis=>{return rfq.biddingDetails.pricingBasis === pricingBasis.value})} 
                  displayKey="name" 
                  name="pricingBasis" 
                  label="Select.." 
                  onSelect={this.onSelect}
                  className={Cx('event-select wt-200 br-5')}
                />
              </div>
            </section>
          </section>
          <section className="pl-15 mt-20 flex separator" />
          <section className="mb-20 geofence  pl-20 pr-20 pt-20 pb-20 br-5  border-1px-regent-gray">
            <header className="fBolder fs-18 mb-10 header-text">
              T & C and other documents <span className='error-color fs-16 fBold'>*</span>
            </header>
            <div className="   wt-220">
              <Upload onChange={this.onChange}>
                <button
                  className={classNames(
                    "ht-38 wt-250 fs-16 ff pl-30 pr-30 mr-30 border-theme-1"
                  )}
                  style={{ color: "#627fe9" }}
                >
                <span className="flex flex-around pr-20 pl-20">
                <UploadIcon width="16" height="16" />
                Upload here
              </span>
       
                  
                </button>
              </Upload>
            </div>
            <div className={Cx("flex flex-wrap", {
                        "flex-between": (rfq.documents || []).length > 2,
                        "flex-around": (rfq.documents || []).length <= 2
                    })}>
                        {
                            rfq.documents.map((document, index)=> {
                                return (
                                    <a key={uuidv4()} className="pr wt-150 mr-50 curP mb-40" 
                                        // href={document.url} 
                                        onClick={() => this.downloadUploadedFile(document.name)}>
                                        <CloseIcon className="pa t-0 r-0 curP" onClick={this.removeDocument.bind(this, index)}/>
                                        <img src={Preview} alt={document.name} className="wt-150 ht-150"/>
                                        <span className="fSemibold fs-14 header-medium-color">{document.name}</span>
                                    </a>
                                )
                            })
                        }
                    </div>
            
          </section>
          <section className="pl-15 mt-20 flex separator" />
          <section className="mb-20  pl-20 pr-20 pt-20 pb-20 br-5 border-1px-regent-gray">
            <header className="fBolder fs-18 mb-10 header-text">
              Contract Note
            </header>
            <div>
              <textarea
                // style={{ border: "1px solid blue" }}
                className={"col-1 br-5 pb-5 pt-5 fs-14 border-theme-1"}
                value={rfq.rfqDetails.contractNote}
                onChange={this.handleContractNotes}
              />
            </div>
          </section>
          <section className="pl-15 mt-20 flex separator" />
          <section className="mb-20  pl-20 pr-20 pt-20 pb-20 br-5 border-1px-regent-gray">
            <header className="fBolder fs-18 mb-10 header-text">
              Transporters
            </header>
            {groups.length > 0 && <TransportersCard
              searchGroupsAndTransporters={this.searchGroupsAndTransporters}
              transporters={transporters || []}
              rfq={rfq}
              groups={groups || []}
              setGroups={(data) => {
                rfq.setGroups(data);
                this.setState({
                    transporterAdded: true
                })
              }}
          />}
          </section>
          {this.props.isPreview &&
          <>
            <section>
              <header className="fBolder fs-18 mb-10 header-text">
                Uploaded RFQ
              </header>
              <Table striped className="upload-rfq-table col-1 fs-18">
              <thead>
                    <tr>
                      <th className="upload-td-th upload-th">RFQ Name</th>
                      <th className="upload-td-th upload-th">RA Strategy</th>
                      <th className="upload-td-th upload-th">No of Lanes</th>
                      <th className="upload-td-th upload-th">Bid Date</th>
                      <th className="upload-td-th upload-th">Time</th>
                      <th className="upload-td-th upload-th">Duration</th>
                      <th className="upload-td-th upload-th">Hours/Minutes</th>
                    </tr>
                </thead>
                <tbody>
                {(eventDetails.event_rfq_list || []).map((rfqEvent, evtIndex) => {
                  return(
                    <tr key={evtIndex}>
                      <td className="upload-td-th"><a onClick={() => {
                        location.href = `/editEvent/${rfqEvent.event_id}/${rfqEvent.rfq_id}/${rfq.id}`;
                      }}>{rfqEvent.rfq_name}</a></td>
                      <td className="upload-td-th">{rfqEvent.is_accept_partial_solution ? "Partial" : "Complete"}</td>
                      <td className="upload-td-th">{rfqEvent.trips_count}</td>
                      <td className="upload-td-th">{rfqEvent.bidding_start && Moment(rfqEvent.bidding_start).format('DD/MMM/YYYY') || ''}</td>
                      <td className="upload-td-th">{rfqEvent.bidding_start && Moment(rfqEvent.bidding_start).format('hh:mm:ss a') || ''}</td>
                      <td className="upload-td-th">{rfqEvent.event_bid_end_duration || ''}</td>
                      <td className="upload-td-th">{rfqEvent.event_bid_duration_name || ''}</td>
                    </tr>
                  )
                })}
                </tbody>
              </Table>
            </section>
          </>}
      
          <section className=" mb-20   pl-20 pr-20 pt-20 pb-20 br-5 ">
          {this.props.isPreview ? 
          <div className="wt-150 ml-25 mt-50 fRight mb-50">
            <Button className="button-classic" value="Schedule" onClick={this.onScheduleEvent} />
          </div>
          :
          <div className="wt-150 ml-25 mt-50 fRight mb-50">
            <Button className={Cx("button-classic", {
              'disabled': this.validateData()
            })} value="Next" onClick={() => this.onSaveEvent(2)} />
          </div>}
        <div className="wt-150 ml-25 mt-50 fRight mb-50">
          <Button className="button-classic" value="Save" onClick={() => this.onSaveEvent(1)} />
        </div>
        <div className="wt-150 ml-25 mt-50 fRight mb-50">
          <Button className="button-classic " value="Previous" onClick={this.goBack} />
        </div>
          </section>
                        </>}
        </section>
      </Sticky></div>
    );
  }
}

const mapStateToProps = ({ constants, rfq, contracting }) => {
    return {
      transporters: constants.transporters || [],
      groups: constants.groups || [],
      contractTenureList: constants.contractTenureList || [],
      productCategories: constants.productCategories || [],
      pricingBasis: constants.pricingBasis || [],
      paymentCycles: constants.paymentCycles || [],
      packingTypes: constants.packingTypes || [],
      loader: contracting.loader || false,
      rfq: rfq.createdRFQ || null,
      eventDetails: rfq.eventDetails || {}
    }
}
export default connect(mapStateToProps)(NewEvent);